// NorthMarlow, eigen code, clean-room 20-10-2026
(function () {
  'use strict';

  var READY_ATTR = 'data-nmp-ready';

  function prefersReducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* ---------------- Verzenddatum ---------------- */

  function nextShipDate(now) {
    var d = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    if (d.getDay() === 0) {
      d.setDate(d.getDate() + 1);
    }
    return d;
  }

  function formatShipDate(d) {
    try {
      return d.toLocaleDateString('es-ES', { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (err) {
      var days = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];
      var months = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sept', 'oct', 'nov', 'dic'];
      return days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
    }
  }

  function fillShipDates(scope) {
    var nodes = (scope || document).querySelectorAll('[data-nmp-ship-date]');
    if (!nodes.length) return;
    var label = formatShipDate(nextShipDate(new Date()));
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = label;
    }
  }

  /* ---------------- Reviews: lees meer ---------------- */

  function syncMoreButton(text, button) {
    if (text.classList.contains('nmp-reviews-text-open')) {
      button.hidden = false;
      return;
    }
    button.hidden = !(text.scrollHeight > text.clientHeight + 1);
  }

  function setupReadMore(card) {
    var text = card.querySelector('[data-nmp-review-text]');
    var button = card.querySelector('[data-nmp-review-more]');
    if (!text || !button) return null;

    var moreLabel = button.getAttribute('data-nmp-label-more') || 'Leer más';
    var lessLabel = button.getAttribute('data-nmp-label-less') || 'Leer menos';

    button.addEventListener('click', function () {
      var open = !text.classList.contains('nmp-reviews-text-open');
      text.classList.toggle('nmp-reviews-text-open', open);
      button.textContent = open ? lessLabel : moreLabel;
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) syncMoreButton(text, button);
    });

    syncMoreButton(text, button);
    return function () {
      syncMoreButton(text, button);
    };
  }

  /* ---------------- Reviews: carrousel ---------------- */

  function stepSize(track) {
    var card = track.querySelector('[data-nmp-card]');
    if (!card) return track.clientWidth;
    var style = window.getComputedStyle(track);
    var gap = parseFloat(style.columnGap || style.gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function slide(track, direction) {
    var distance = direction * stepSize(track);
    var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
    if (typeof track.scrollBy === 'function') {
      try {
        track.scrollBy({ left: distance, behavior: behavior });
        return;
      } catch (err) {
        /* oudere browsers: val terug op scrollLeft */
      }
    }
    track.scrollLeft += distance;
  }

  function initCarousel(root) {
    if (!root || root.getAttribute(READY_ATTR) === '1') return;
    var track = root.querySelector('[data-nmp-track]');
    if (!track) return;
    root.setAttribute(READY_ATTR, '1');

    var prev = root.querySelector('[data-nmp-prev]');
    var next = root.querySelector('[data-nmp-next]');
    if (prev) prev.addEventListener('click', function () { slide(track, -1); });
    if (next) next.addEventListener('click', function () { slide(track, 1); });

    var cards = track.querySelectorAll('[data-nmp-card]');
    var refreshers = [];
    for (var i = 0; i < cards.length; i++) {
      var refresh = setupReadMore(cards[i]);
      if (refresh) refreshers.push(refresh);
    }
    if (!refreshers.length) return;

    var pending = null;
    function refreshAll() {
      pending = null;
      for (var j = 0; j < refreshers.length; j++) refreshers[j]();
    }
    function scheduleRefresh() {
      if (pending) return;
      pending = window.requestAnimationFrame ? window.requestAnimationFrame(refreshAll) : setTimeout(refreshAll, 50);
    }

    if (typeof window.ResizeObserver === 'function') {
      new window.ResizeObserver(scheduleRefresh).observe(track);
    } else {
      window.addEventListener('resize', scheduleRefresh);
    }
    if (document.fonts && document.fonts.ready && typeof document.fonts.ready.then === 'function') {
      document.fonts.ready.then(scheduleRefresh);
    }
  }

  function initCarousels(scope) {
    var roots = (scope || document).querySelectorAll('[data-nmp-carousel]');
    for (var i = 0; i < roots.length; i++) initCarousel(roots[i]);
  }

  /* ---------------- Start ---------------- */

  function init(scope) {
    try { fillShipDates(scope); } catch (err) { /* onderdeel ontbreekt of faalt: rest gaat door */ }
    try { initCarousels(scope); } catch (err) { /* idem */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Thema-editor: secties worden opnieuw geladen zonder paginaverversing.
  document.addEventListener('shopify:section:load', function (event) {
    init(event && event.target ? event.target : document);
  });
})();
